import { render } from "./ReviewNavigation.vue?vue&type=template&id=50dfbdc0&ts=true"
import script from "./ReviewNavigation.ts?vue&type=script&lang=ts&external"
export * from "./ReviewNavigation.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__